export const COORDINATE_REQUEST_GENDERS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];
